import debounce from "lodash.debounce";
import i18n from "@/factories/i18n.factory";
import * as TranslationsDAO from "@/dao/translations-dao";

const defaultLocale = "en_GB";

const setI18nLocale = (langCode, messages) => {
  if (window.location.search.indexOf("no-i18n") >= 0) {
    return;
  }
  i18n.locale = langCode;
  i18n.setLocaleMessage(langCode, messages);
};

export default {
  async setLanguage({ commit, getters }, langCode = defaultLocale) {
    if (langCode !== getters.currentLanguage) {
      commit("language", langCode);
      const messagesArray = await TranslationsDAO.getTranslations(langCode);
      const messages = messagesArray.reduce((msgs, translation) => {
        const result = msgs;
        result[translation.key] = translation.text;
        return result;
      }, {});
      setI18nLocale(langCode, messages);
    }
  },
  postMissingTranslations: debounce(({ state, commit }, { locale }) => {
    TranslationsDAO.getMissingTranslations(
      locale,
      Array.from(state.missingTranslations).map(val => ({ key: val }))
    );
    commit("setMissingTranslations", new Set());
  }, 3000),

  addMissingTranslation({ commit, dispatch }, { locale, translationKey }) {
    commit("addMissingTranslation", translationKey);
    dispatch("postMissingTranslations", { locale });
  }
};
